(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-description-toggle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collection-description-toggle')) {
    class CollectionDescriptionToggle extends HTMLElement {
      connectedCallback() {
        this.contentElement = this.querySelector('[data-collection-description-content]');
        this.buttonElement = this.querySelector('[data-collection-description-button]');
        this.moreLabel = this.querySelector('[data-collection-description-more]');
        this.lessLabel = this.querySelector('[data-collection-description-less]');

        if (!this.contentElement || !this.buttonElement || !this.moreLabel || !this.lessLabel) {
          return;
        }

        this.handleToggle = this.handleToggle.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.setAttribute('data-enhanced', '');
        this.buttonElement.addEventListener('click', this.handleToggle);
        window.addEventListener('resize', this.handleResize, { passive: true });

        requestAnimationFrame(() => this.updateButtonVisibility());
      }

      disconnectedCallback() {
        if (this.buttonElement) {
          this.buttonElement.removeEventListener('click', this.handleToggle);
        }

        window.removeEventListener('resize', this.handleResize);
      }

      handleToggle() {
        const isExpanded = this.hasAttribute('data-expanded');
        const nextExpanded = !isExpanded;

        this.toggleAttribute('data-expanded', nextExpanded);
        this.buttonElement.setAttribute('aria-expanded', String(nextExpanded));
        this.moreLabel.hidden = nextExpanded;
        this.lessLabel.hidden = !nextExpanded;

        if (!nextExpanded) {
          requestAnimationFrame(() => this.updateButtonVisibility());
        }
      }

      handleResize() {
        if (this.hasAttribute('data-expanded')) {
          return;
        }

        window.clearTimeout(this.resizeTimeout);
        this.resizeTimeout = window.setTimeout(() => this.updateButtonVisibility(), 150);
      }

      updateButtonVisibility() {
        const overflow = this.contentElement.scrollHeight - this.contentElement.clientHeight;
        const lineHeight = Number.parseFloat(window.getComputedStyle(this.contentElement).lineHeight) || 0;
        const overflowTolerance = Math.max(2, lineHeight * 0.2);

        this.buttonElement.hidden = overflow <= overflowTolerance;
      }
    }

    customElements.define('collection-description-toggle', CollectionDescriptionToggle);
  }
  } catch(e) { console.error(e); }
})();

})();
